export const EmptyMessage = (text: string) => {
    return (
      <div className="gfa-rowy mt-2 w-100">
        <div className="alert alert-warning gfa-warning">{text}</div>
      </div>
    );
};